import { useCallback } from 'react';

import { useUtilityContext } from '@change-corgi/core-react/utilityContext';

import type { ContactDecisionMakerReasonId } from '#src/app/shared/utils/contactDecisionMaker';

import type { DraftResult } from './api';
import { generateDecisionMakerMessageDraft } from './api';

type Params = {
	petitionId: string;
	decisionMakerId: string;
	decisionMakerName: string;
	reasonId: ContactDecisionMakerReasonId;
	story: string;
};

/**
 * Returns a caller that drafts the message. It never rejects and never surfaces an error state — see
 * {@link generateDecisionMakerMessageDraft} for why the supporter always ends up on the review screen.
 */
export function useGenerateDecisionMakerMessageDraft(): (params: Params) => Promise<DraftResult> {
	const utilityContext = useUtilityContext();

	return useCallback(
		async (params: Params) => generateDecisionMakerMessageDraft(params, utilityContext),
		[utilityContext],
	);
}
